/* eslint-disable jsx-a11y/media-has-caption */
import PropTypes from 'prop-types'
import { forwardRef } from 'react'

import { Box, Icon, Image, Text } from '@redriverpress/system'

const UserFlashcardDragOverlay = forwardRef(({ thumbnail, userTitle }, ref) => (
  <Box
    ref={ref}
    bg='white'
    borderRadius='rounded'
    p={3}
    position='relative'
    boxShadow={3}
    zIndex={1}
  >
    <Box position='absolute' top={1} right={1}>
      <Icon weight='regular' icon='ellipsis-v' pr='2px' />
      <Icon weight='regular' icon='ellipsis-v' />
    </Box>
    <Image
      height={100}
      width={100}
      display='block'
      mx='auto'
      src={thumbnail}
      alt=''
    />
    <Box display='flex' flexDirection='column' alignItems='center'>
      <Text py={2} textAlign='center' fontWeight={600}>
        {userTitle}
      </Text>
    </Box>
  </Box>
))

UserFlashcardDragOverlay.propTypes = {
  thumbnail: PropTypes.string.isRequired,
  userTitle: PropTypes.string.isRequired,
}

export default UserFlashcardDragOverlay
